<template>
  <div ref="carouselButtonWrapper" class="carousel-button" @click="onSwipe">
    <button ref="carouselButton" class="carousel-button__button">
      <AppCarouselCursor
        :x="x"
        :y="y"
        :rerender="state.rerender"
        :parent="$refs.carouselButton"
        :direction="props.direction"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useSwiper } from 'swiper/vue'
import { onUpdated, ref } from 'vue'
import { useMouse } from '~/composables/useMouse'
import { reactive } from '#imports'

const state = reactive({
  rerender: new Date().getTime()
})

const props = defineProps<{
  direction: string,
  visible: boolean,
  full: boolean
}>()

const carouselButton = ref<HTMLElement>()
const carouselButtonWrapper = ref<HTMLElement>()
const swiper = useSwiper()

const onSwipe = () => {
  if (props.direction === 'left') {
    swiper.value.slidePrev()
  } else {
    swiper.value.slideNext()
  }
  updateNav()
}

onUpdated(() => {
  updateNav()
})

const updateNav = () => {
  carouselButtonWrapper.value?.classList.toggle('carousel-button--hidden', !props.visible)
    carouselButtonWrapper.value?.classList.toggle('carousel-button--full', props.full)
  state.rerender = new Date().getTime()
}

const { x, y } = useMouse()
</script>

<style scoped lang="postcss">
.carousel-button {
  position: absolute;
  top: 0px;
  z-index: 10;
  height: 100%;
  width: 50%;

  &--hidden {
    display: none;
  }

  &--full {
    width: 100%;
  }

  &__button {
    position: relative;
    width: 100%;
    cursor: none;
    height: calc(100% - 40px);
  }
}
</style>
